import { create } from "zustand";
import { ICompanyAccess } from "../../../types/companyaccess.type";

type CompanyAccessStore = {
  companyAccess: ICompanyAccess | null;
  addCompanyAccess: (companyAccess: ICompanyAccess) => void;
  removeCompanyAccess: () => void;
};

export const useCompanyAccessStore = create<CompanyAccessStore>((set) => {
  const storedCompanyAccess = localStorage.getItem("companyAccess");
  const initialCompanyAccess = storedCompanyAccess
    ? JSON.parse(storedCompanyAccess)
    : null;

  return {
    companyAccess: initialCompanyAccess,
    addCompanyAccess: (companyAccess) => {
      set(() => ({ companyAccess }));
      const dataToStore = companyAccess;

      localStorage.setItem("companyAccess", JSON.stringify(dataToStore));
    },
    removeCompanyAccess: () => {
      set(() => ({ companyAccess: null }));
      localStorage.removeItem("companyAccess");
    },
  };
});
